module.exports = __webpack_public_path__ + "static/media/tesla.0737c44b.jpg";